import React from 'react';
import styled from 'styled-components';
import CompositeLogo from './composite-logo';

export default function Header({ children }: { children?: React.ReactNode }) {
  return (
    <Wrapper>
      <CompositeLogo />
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.header`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: 2.5rem;
  justify-content: space-between;
  padding: 1rem;
`;
